export * from './RegistrationHospitalConfirmationDialog';
